"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatrixRow = void 0;
class MatrixRow {
    constructor(obj) {
        // Take in an object, and assign every property from that
        // object onto this newly created object.
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.MatrixRow = MatrixRow;
//# sourceMappingURL=MatrixRow.js.map